import { __extends } from "tslib";
import { ListParallelDataRequest, ListParallelDataResponse } from "../models/models_0";
import { deserializeAws_json1_1ListParallelDataCommand, serializeAws_json1_1ListParallelDataCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Provides a list of your parallel data resources in Amazon Translate.</p>
 */
var ListParallelDataCommand = /** @class */ (function (_super) {
    __extends(ListParallelDataCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListParallelDataCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    ListParallelDataCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "TranslateClient";
        var commandName = "ListParallelDataCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: ListParallelDataRequest.filterSensitiveLog,
            outputFilterSensitiveLog: ListParallelDataResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListParallelDataCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1ListParallelDataCommand(input, context);
    };
    ListParallelDataCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1ListParallelDataCommand(output, context);
    };
    return ListParallelDataCommand;
}($Command));
export { ListParallelDataCommand };
//# sourceMappingURL=ListParallelDataCommand.js.map